import React from 'react';

import './ContentItemViewPublishingRightsItem.scss';

interface ContentItemViewPublishingRightsItemProps {
    rightsType: string;
    availabilityStart: string;
    availabilityEnd: string;
    screenings: number | null;
}

export default function ContentItemViewPublishingRightsItem(props: ContentItemViewPublishingRightsItemProps) {
    const {
        rightsType,
        availabilityStart,
        availabilityEnd,
        screenings,
    } = props;
    
    return (
        <div className="main__block">
            <div className="main__block__item">
                <div className="main__block__type">
                    Type
                </div>
                <div className="main__block__value">
                    {rightsType}
                </div>
                <div className="main__block__type">
                    Start
                </div>
                <div className="main__block__value">
                    {availabilityStart} (UTC)
                </div>
            
            </div>
            <div className="main__block__item">
                <div className="main__block__type">
                    Screenings
                </div>
                <div className="main__block__value">
                    {screenings}
                </div>
                <div className="main__block__type">
                    End
                </div>
                <div className="main__block__value">
                    {availabilityEnd} (UTC)
                </div>
            </div>
        
        </div>
    );
}
